import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=0f404007&scoped=true&"
import script from "./youtube.vue?vue&type=script&lang=babel&"
export * from "./youtube.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f404007",
  null
  
)

export default component.exports